
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/apply",
      function () {
        return require("private-next-pages/exhibition/apply/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibition/apply"])
      });
    }
  